import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Article } from '@/modules/articles/model/article';
import { AgedDateFormat } from '@/core/date/export';
import styles from './bookmark-list.module.css';

export default function BookmarkCard({
  item,
  onOpen,
  onDelete,
}: {
  item: Article;
  onOpen: () => void;
  onDelete: () => void;
}) {
  return (
    <div className={styles.bookmarkCard} onClick={onOpen}>
      <div className={styles.bookmarkHeadline}>
        <strong className={styles.bookmarkLink}>{item.headline}</strong>
      </div>
      <div className={'d-flex justify-content-between align-items-center text-muted mt-2'}>
        <small>
          <AgedDateFormat format={'MMM D, h:mm a'} date={item.firstcreated} />
        </small>
        <button
          style={{ fontFamily: 'Inter' }}
          className={'btn btn-link link-danger btn-sm'}
          onClick={event => {
            event.stopPropagation();
            onDelete();
          }}
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
}
